import React from 'react';
import { type fabric } from 'fabric';
import { ApplicationView, useController } from '@aha-app/mvc';
import ToolButton from '../toolbars/ToolButton';
import WhiteboardController from '../controllers/WhiteboardController';
import styles from '../styles.module.css';
import { isEmbeddedAssistantArtifact } from '../objects/guards';
import type EmbeddedAssistantArtifact from '../objects/EmbeddedAssistantArtifact';
import Tool, {
  type IToolActionInput,
  type IToolAvailableInput,
  type IToolEnabledInput,
} from './Tool';

const artifactFromSelection = (
  selection?: fabric.Object | null
): EmbeddedAssistantArtifact | null => {
  if (!selection) return null;

  const candidate =
    (
      selection as unknown as { firstObject?: () => fabric.Object }
    )?.firstObject?.() ?? selection;

  return isEmbeddedAssistantArtifact(candidate) ? candidate : null;
};

class ToolEditEmbeddedAssistantArtifact extends Tool {
  static toolName = 'Create new version';

  static availableWhenLocked = true;

  static available({ selection }: IToolAvailableInput): boolean {
    return Boolean(artifactFromSelection(selection));
  }

  static enabled(args: IToolEnabledInput) {
    return this.available(args);
  }

  static action({ controller, selection }: IToolActionInput) {
    const artifact = artifactFromSelection(selection);
    if (!artifact) return;

    const stickyReference = new URL(
      artifact.artifactUrl,
      window.location.origin
    ).toString();

    controller.actionOpenSidePanel('assistant', {
      agentName: 'AppPrototypeAgent',
      stickyReferences: [stickyReference],
      startNewChat: true,
    });
  }

  static buttonComponent() {
    return ApplicationView(() => {
      const controller = useController(WhiteboardController);

      return (
        <ToolButton
          className={styles.toolButtonWide}
          onClick={() => controller.actionApplyTool(this)}
          disabled={!controller.isToolEnabled({ tool: this })}
          tool={this}
        >
          <span style={{ height: 30, marginRight: 8 }}>
            <aha-ai-icon size={18} />
          </span>
          <span style={{ fontSize: 12 }}>{this.toolName}</span>
        </ToolButton>
      );
    });
  }
}

export default ToolEditEmbeddedAssistantArtifact;
